import React, { useState } from 'react';
import clsx from 'clsx';

// Material
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';

// Icons
import FilterListIcon from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';
import DeleteIcon from 'components/Icons/Delete';

// Styles
import useStyles from './ToolBar.styles';

interface StateProps {
  primary: string | React.ReactNode;
  secondary?: string | React.ReactNode;
  borderTop?: boolean | undefined;
  trash?: { disable: boolean; handleClick: () => void };
  filter: {
    value: string;
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  };
}

type Props = StateProps;

const ToolBar: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { primary, secondary, borderTop, filter, trash } = props;
  const [openFilter, toggleFilter] = useState(false);

  return (
    <Toolbar
      className={clsx({
        [classes.root]: true,
        [classes.borderTop]: borderTop,
      })}>
      <Grid
        alignItems='center'
        container
        justifyContent='space-between'
        spacing={2}>
        <Grid item lg={5} md={5} sm={5} xl={5} xs={5}>
          <Typography variant='h6'>{primary}</Typography>
          {secondary && <Typography component='div'>{secondary}</Typography>}
        </Grid>
        <Grid item lg={7} md={7} sm={7} xl={7} xs={7}>
          <Grid
            alignItems='center'
            container
            justifyContent='flex-end'
            wrap='nowrap'>
            <Grid item>
              <FormControl className={classes.searchFormControl}>
                <TextField
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  className={clsx({ [classes.hideDisplay]: !openFilter })}
                  id='text-field-search'
                  onChange={filter.handleChange}
                  placeholder='Pesquisar'
                  value={filter.value}
                  variant='outlined'
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Tooltip placement='top' title='Filtrar'>
                <IconButton onClick={() => toggleFilter(!openFilter)}>
                  <FilterListIcon />
                </IconButton>
              </Tooltip>
            </Grid>
            {trash && (
              <Grid item>
                <Tooltip placement='top' title='Deletar Selecionados'>
                  <span>
                    <IconButton
                      disabled={trash.disable}
                      onClick={() => trash.handleClick()}>
                      <DeleteIcon />
                    </IconButton>
                  </span>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Toolbar>
  );
};

export { ToolBar };
export default Toolbar;
